module.exports = __webpack_public_path__ + "static/media/Imagen_10.05425496.jpg";